<div class="sessionbingo-info-container">
    @if (PackageDetails && !packagePurchased) {
        <div>
            <div class="sessionbingo-info-header">
                <span class="sessionbingo-info-title">{{ content.info }}</span
                ><i class="theme-close-small" (click)="close()"></i>
            </div>
            <div class="sessionbingo-info-body">
                <div class="info-item">
                    <div class="game-room">{{ content.GameRoom }}</div>
                    <div class="bingo-balls">
                        @for (gameRoomData of PackageDetails.uniqueBingoType; track gameRoomData) {
                            <div class="bingo-ball">
                                <div class="{{ 'ball-type ball-type' + '-' + gameRoomData }}">
                                    {{ gameRoomData }}
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="info-item">
                    <div class="game-feature">{{ content.GameFeature }}</div>
                    <div class="feature-icons">
                        @for (gamefeatureData of PackageDetails.uniqueGameFeature; track gamefeatureData) {
                            <span class="room-feature" (click)="featureClicked(gamefeatureData)">
                                <bg-feature-icon [feature]="gamefeatureData" />
                            </span>
                        }
                    </div>
                </div>
                <bg-buynow-body [packageDetails]="PackageDetails" [isInGameClient]="isInGameClient" />
            </div>
        </div>
    } @else if (packagePurchased) {
        <div class="package-purchased">
            <div class="package-gamescompleted">
                {{ content.GamesCompleted }}
            </div>
        </div>
    }
</div>
